/**
 * useDemoMode Hook - Demo Version
 *
 * In the demo deployment, demo mode is always enabled and cannot be changed.
 * This ensures all queries are scoped to the demo client.
 */

import { useCallback } from 'react';

/** The client name used in demo mode */
export const DEMO_CLIENT = 'Valley Equipment';

interface UseDemoModeReturn {
  /** Whether demo mode is currently enabled (always true in demo) */
  isDemoMode: boolean;
  /** No-op in demo version - demo mode cannot be changed */
  setDemoMode: (enabled: boolean) => void;
  /** The client name to use (always DEMO_CLIENT in demo) */
  demoClient: string;
}

export function useDemoMode(): UseDemoModeReturn {
  // Demo mode is always enabled in the demo deployment
  // No-op setter prevents any attempts to change it
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const setDemoMode = useCallback((_enabled: boolean) => {
    // Intentionally empty - demo mode cannot be toggled
  }, []);

  return {
    isDemoMode: true,
    setDemoMode,
    demoClient: DEMO_CLIENT,
  };
}
